import { Truck } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-[#1F2937] text-white/80 mt-20">
    <div className="max-w-7xl mx-auto px-5 py-14 grid md:grid-cols-4 gap-8">
      <div>
        <div className="flex items-center gap-2 mb-3">
          <span className="w-8 h-8 rounded-full bg-[#0FB5A6] flex items-center justify-center">
            <Truck className="w-4 h-4 text-white" />
          </span>
          <span className="font-display font-extrabold text-lg text-white">FlavorFlow</span>
        </div>
        <p className="text-sm text-white/60 leading-relaxed">
          Find your favorite food trucks live and book them for events across Wisconsin.
        </p>
      </div>
      <FooterCol title="Discover" links={[["Live Map", "/explore"], ["Events", "/events"], ["Corporate Booking", "/corporate"]]} />
      <FooterCol title="For Owners" links={[["Pricing & Plans", "/pricing"], ["List Your Truck", "/register"], ["Log in", "/login"]]} />
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#F2635F] mb-3">Launching in</p>
        <p className="text-sm">Green Bay · Appleton · Oshkosh · Fox Valley</p>
        <p className="text-sm text-white/50 mt-1 mb-4">Wisconsin. Statewide coming soon.</p>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#F2635F] mb-2">Get in touch</p>
        <a href="mailto:brookekrause25@gmail.com" className="block text-sm hover:text-white transition-colors">brookekrause25@gmail.com</a>
        <a href="tel:+19204612873" className="block text-sm hover:text-white transition-colors">(920) 461-2873</a>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
      © 2026 FlavorFlow. Made in Wisconsin.
    </div>
  </footer>
);

const FooterCol = ({ title, links }) => (
  <div>
    <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#F2635F] mb-3">{title}</p>
    <ul className="space-y-2">
      {links.map(([label, to]) => (
        <li key={label}>
          <Link to={to} className="text-sm hover:text-white transition-colors">{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);
